import { AuthService, createAuthService } from '@lumora/common';
import React, { useMemo } from 'react';

import { WebSessionAdapter } from '../services/auth/webSessionAdapter';

import { AuthServiceContext } from './AuthServiceContextDefinition';

interface AuthServiceProviderProps {
  children: React.ReactNode;
  /**
   * Optional AuthService instance. If not provided, a new instance will be created
   * with WebSessionAdapter
   */
  authService?: AuthService;
}

/**
 * Provider component that creates and provides AuthService instance to the component tree
 */
export const AuthServiceProvider: React.FC<AuthServiceProviderProps> = ({
  children,
  authService: providedAuthService,
}) => {
  // Create authService instance once with web-specific adapter
  const authService = useMemo(() => {
    if (providedAuthService) {
      return providedAuthService;
    }
    const webAdapter = new WebSessionAdapter();
    return createAuthService(undefined, webAdapter);
  }, [providedAuthService]);

  return (
    <AuthServiceContext.Provider value={authService}>
      {children}
    </AuthServiceContext.Provider>
  );
};
